<button mat-raised-button (click)="onClick()" [disabled]="disabled">Excel</button>
